import React, { useEffect } from 'react';

import { expVal } from '@confluence/feature-experiments';

import { ANALYTICS_OPERATIONAL_SUBJECT } from '../constants/snippetAnalytics.ts';
import { useSnippetAnalytics } from '../hooks/useSnippetAnalytics.ts';
import { useSnippetsFetchAnalytics } from '../hooks/useSnippetsFetchAnalytics.ts';

import { useSnippetsActions } from './snippetsStore.ts';

/**
 * Provider component that ensures snippets are fetched before the component tree renders.
 * The first fetch resolves site config (isSnippetSharingForSiteEnabled) inside the fetch flow and stores it.
 */
export const SnippetsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const snippetsActions = useSnippetsActions();
	const { fireFailedAnalytic } = useSnippetAnalytics();
	useSnippetsFetchAnalytics();

	useEffect(() => {
		if (!expVal('cc_snippets', 'isEnabled', false)) {
			return;
		}
		snippetsActions.fetchSnippets().catch(() => {
			fireFailedAnalytic(ANALYTICS_OPERATIONAL_SUBJECT.SNIPPET_API_FETCH, {});
		});
	}, [snippetsActions, fireFailedAnalytic]);

	// Render children immediately - the fetch happens in the background
	return <>{children}</>;
};
